import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { FormField } from '../models/form-field';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';

const baseUrl = environment.hostService + '/EsquemaVariable';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {

  constructor(private _http: HttpClientService) { }

  toFormGroup(inputs: FormField<string>[]): FormGroup
  {
    
    const group: any = {};
    inputs.forEach(input =>
    {
      let validator: ValidatorFn[] = input.required ? [Validators.required] : [];
      switch (input.validator)
      {
        case "email":
          validator.push(Validators.email);
          break;
        default:
          break;
      }
      group[input.key] = validator.length > 0 ? new FormControl(input.value || '', validator)
        : new FormControl(input.value || '');
    });

    return new FormGroup(group);
  }

  getFormFields()
  {

    const inputs: FormField<string>[] = [

      new FormField<string>({
        controlType: "textbox",
        key: 'name',
        label: 'Name',
        required: true
      }),

      new FormField<string>({
        controlType: "textbox",
        key: 'email',
        label: 'Email',
        type: 'email',
        required: true,
        validator: "email"
      }),

      new FormField<string>({
        controlType: "dropdown",
        key: 'country',
        label: 'Country',
        options: [
          { key: 'usa', value: 'United States of America' },
          { key: 'br', value: 'Brazil' },
          { key: 'other', value: 'Other' }
        ]
      }),

      new FormField<string>({
        controlType: "checkbox",
        key: 'agree',
        label: 'I accept terms and services',
        type: 'checkbox',
        required: true
      }),

      new FormField<string>({
        controlType: "radio",
        key: 'sex',
        label: 'Sex',
        type: 'radio',
        options: [
          { key: 'male', value: 'Male' },
          { key: 'female', value: 'Female' }
        ]
      }),

      new FormField<string>({
        controlType: "textarea",
        key: 'message',
        label: 'Mesage',
        type: 'textarea'
      }),

      new FormField<string>({
        controlType: "date",
        key: 'date',
        label: 'Fecha',
        type: 'date'
      }),

      new FormField<string>({
        controlType: "number",
        key: 'number',
        label: 'Numero',
        type: 'number'
      })
    ];

    return of(inputs);
  }

  getEsquemasVariables(esquemaId: number)
  {
    return this._http.get<any>({ url: baseUrl + '/GetListByEsquema/' + esquemaId });
  }
}

